// extracted by mini-css-extract-plugin
export var clientContainer = "slider-module--client-container--14662";
export var clientLogo = "slider-module--client-logo--9663f";
export var logoContainer = "slider-module--logo-container--c05ae";